import IconButton from '@/global/components/Button/IconButton'
import { GridMenuButton } from '@/global/components/DataGrid/components/CustomGridToolBar/MenuComponents'
import { optionsColumn } from '@/global/components/DataGrid/hooks/useDataGridPro'
import { SelectEmpresa } from 'global/components/Selects'
import ContentGuide from 'global/guides/ContentGuide'
import { hasPermission } from 'hooks/useBackendMenu'
import { PencilIcon, PowerOffIcon, Trash2Icon } from 'lucide-react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { Ocorrencia, ocorrencia } from 'service/api'
import { useStore } from 'store'
import SwitchAtalhoOcorrencia from 'templates/Cadastro/Ocorrencias/SwitchAtalho'

export default function Ocorrencias() {
    const empresaId = useStore(state => state.companyId)
    const { data, isLoading } = ocorrencia.useFetch({
        queryParams: {
            empresaId,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Ocorrências']}>
                    <SelectEmpresa hideWhenSingle />
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    rows={data}
                    columns={[
                        {
                            field: 'codigo',
                            headerName: 'Código',
                            width: 130,
                            type: 'number',
                        },
                        {
                            field: 'descricao',
                            headerName: 'Descrição',
                            flex: 1,
                        },
                        {
                            ...optionsColumn,
                            sortable: true,
                            filterable: true,
                            field: 'atalho',
                            headerName: 'Atalho',
                            headerAlign: 'center',
                            width: 80,
                            align: 'center',
                            type: 'SN',
                            renderCell: SwitchAtalhoOcorrencia,
                        },
                        {
                            ...optionsColumn,
                            field: '__editar',
                            renderCell: ({ id }) =>
                                hasPermission(['update', 'Ocorrências'], () => (
                                    <IconButton
                                        title="Editar"
                                        href={`${id}/editar`}
                                    >
                                        <PencilIcon />
                                    </IconButton>
                                )),
                        },
                        {
                            ...optionsColumn,
                            field: '__excluir',
                            renderCell: ({ id }) =>
                                hasPermission(['delete', 'Ocorrências'], () => (
                                    <IconButton
                                        title="Excluir"
                                        href={`${id}/excluir`}
                                    >
                                        <Trash2Icon className="text-error" />
                                    </IconButton>
                                )),
                        },
                    ]}
                    onAdd
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-ocorrencias',
                        },
                        showQuickFilter: true,
                    }}
                    components={{
                        Toolbar: () => (
                            <GridMenuButton
                                startIcon={<PowerOffIcon />}
                                label="Desativados"
                                href="/cadastros/ocorrencias-desativadas"
                            />
                        ),
                    }}
                    loading={isLoading}
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useOcorrenciasOutletContext() {
    return useOutletContext<{ data?: Ocorrencia[] }>()
}
